
export const SHAPE_LIST = "List"
export const SHAPE_KANBAN = "Kanban"

// Authentication
export const TYPE_USER = 0
export const TYPE_ADMIN = 1
export const TYPE_OWNER = 2